/*
  Noma product page helpers (redesign). Loaded with `defer` by the product sections that need them, possibly more than once:
  every piece below is idempotent. Without this file the page is complete: long values are shown in full and the
  compatibility filter box stays hidden.

  <noma-clamp data-lines="4">  clamps long text to N lines and adds a "Read more" / "Show less" button, but only when the text really overflows.
  <noma-compat>                shows the filter box above the compatibility table and hides the rows that do not match.
*/
(function () {
  'use strict';
  if (!window.customElements) return;

  var uid = 0;

  if (!customElements.get('noma-clamp')) {
    customElements.define(
      'noma-clamp',
      class NomaClamp extends HTMLElement {
        connectedCallback() {
          if (this.nomaReady) return;
          this.nomaReady = true;
          this.button = null;
          var lines = parseInt(this.getAttribute('data-lines'), 10);
          this.style.setProperty('--noma-lines', String(lines > 0 ? lines : 4));
          this.measure();
          this.lastWidth = this.clientWidth;
          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(
              function () {
                if (this.clientWidth === this.lastWidth) return;
                this.lastWidth = this.clientWidth;
                this.measure();
              }.bind(this)
            );
            this.observer.observe(this);
          }
          // web fonts change the line breaks after the first measurement
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.measure.bind(this));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        measure() {
          if (this.classList.contains('is-open')) return;
          this.classList.add('is-clamped');
          if (this.scrollHeight > this.clientHeight + 1) {
            this.showButton();
          } else {
            this.classList.remove('is-clamped');
            this.hideButton();
          }
        }

        showButton() {
          if (!this.button) {
            if (!this.id) this.id = 'noma-clamp-' + ++uid;
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'noma-clamp__toggle';
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-controls', this.id);
            button.textContent = 'Read more';
            button.addEventListener('click', this.toggle.bind(this));
            this.insertAdjacentElement('afterend', button);
            this.button = button;
          }
          this.button.hidden = false;
        }

        hideButton() {
          if (this.button) this.button.hidden = true;
        }

        toggle() {
          var open = !this.classList.contains('is-open');
          this.classList.toggle('is-open', open);
          this.classList.toggle('is-clamped', !open);
          this.button.setAttribute('aria-expanded', open ? 'true' : 'false');
          this.button.textContent = open ? 'Show less' : 'Read more';
        }
      }
    );
  }

  if (!customElements.get('noma-compat')) {
    customElements.define(
      'noma-compat',
      class NomaCompat extends HTMLElement {
        connectedCallback() {
          if (this.nomaReady) return;
          var tools = this.querySelector('[data-noma-compat-tools]');
          var input = this.querySelector('[data-noma-compat-input]');
          var rows = Array.prototype.slice.call(this.querySelectorAll('tbody tr'));
          if (!tools || !input || !rows.length) return;
          this.nomaReady = true;

          var count = this.querySelector('[data-noma-compat-count]');
          var empty = this.querySelector('[data-noma-compat-empty]');
          var text = rows.map(function (row) {
            return row.textContent.replace(/\s+/g, ' ').toLowerCase();
          });
          var timer = 0;

          function apply() {
            var words = input.value.toLowerCase().split(/\s+/).filter(Boolean);
            var shown = 0;
            rows.forEach(function (row, i) {
              var match = words.every(function (word) {
                return text[i].indexOf(word) !== -1;
              });
              row.hidden = !match;
              if (match) shown++;
            });
            if (count) count.textContent = shown + ' of ' + rows.length;
            if (empty) empty.hidden = shown !== 0;
          }

          input.addEventListener('input', function () {
            clearTimeout(timer);
            timer = setTimeout(apply, 120);
          });
          tools.hidden = false;
        }
      }
    );
  }
})();
